module.exports = __webpack_public_path__ + "static/media/firstDay1.c77668c4.jpg";